import i18n from "../../../i18n";import { Trans } from "react-i18next";import { SearchInput } from "../../../components/ui";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue } from
"../../../components/ui/select";

export function HolidayFilterBar({
  search,
  setSearch,
  typeFilter,
  setTypeFilter,
  visibilityFilter,
  setVisibilityFilter,
  typeOptions = [],
  departments = [],
  locations = [],
  scopeFilter,
  setScopeFilter
}) {
  return (
    <div className="my-4 flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-3">
      <SearchInput submitOnEnter value={search} onChange={(e) => setSearch(e.target.value)}
        placeholder={i18n.t("formActions.searchRecords")} />

      <Select value={typeFilter} onValueChange={setTypeFilter}>
        <SelectTrigger className="h-10 w-full sm:w-[180px] rounded-xl border-(--color-text-border) bg-white text-sm font-medium">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="All types"><Trans i18nKey="common.allTypes" /></SelectItem>
          {typeOptions.map((cat) =>
          <SelectItem key={cat.categoryId} value={cat.categoryName}>
              {cat.categoryName}
            </SelectItem>
          )}
        </SelectContent>
      </Select>

      <Select
        value={visibilityFilter}
        onValueChange={(v) => {
          setVisibilityFilter(v);
          setScopeFilter("");
        }}>
        
        <SelectTrigger className="h-10 w-full sm:w-[190px] rounded-xl border-(--color-text-border) bg-white text-sm font-medium">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="All visibility"><Trans i18nKey="holidays.allVisibility" /></SelectItem>
          <SelectItem value="Global"><Trans i18nKey="holidays.global" /></SelectItem>
          <SelectItem value="Department"><Trans i18nKey="common.department" /></SelectItem>
          <SelectItem value="Work Location"><Trans i18nKey="holidays.workLocation" /></SelectItem>
        </SelectContent>
      </Select>

      {visibilityFilter === "Department" &&
      <Select value={scopeFilter} onValueChange={setScopeFilter}>
          <SelectTrigger className="h-10 w-full sm:w-[190px] rounded-xl border-(--color-text-border) bg-white text-sm font-medium">
            <SelectValue placeholder={i18n.t("holidays.allDepartments")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all"><Trans i18nKey="holidays.allDepartments" /></SelectItem>
            {departments.map((d) =>
          <SelectItem key={d.departmentId} value={String(d.departmentId)}>
                {d.departmentName}
              </SelectItem>
          )}
          </SelectContent>
        </Select>
      }

      {visibilityFilter === "Work Location" &&
      <Select value={scopeFilter} onValueChange={setScopeFilter}>
          <SelectTrigger className="h-10 w-full sm:w-[190px] rounded-xl border-(--color-text-border) bg-white text-sm font-medium">
            <SelectValue placeholder={i18n.t("holidays.allLocations")} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all"><Trans i18nKey="holidays.allLocations" /></SelectItem>
            {locations.map((l) =>
          <SelectItem key={l.workLocationId} value={String(l.workLocationId)}>
                {l.workLocationName}
              </SelectItem>
          )}
          </SelectContent>
        </Select>
      }
    </div>);

}
